<div class="row">
    <div class="col-12 col-lg-6">
        <div class="counter-wrapper mat-elevation-z1">
            <div>
                <h2>Amaia users</h2>
                <p>
                    Current amount of users registered on the Amaia endpoint.
                </p>
            </div>
            <div class="counter">
                <mat-spinner *ngIf="amaiaCounterIsLoading" diameter="30"></mat-spinner>
                <a [routerLink]="['amaia/users']" *ngIf="!amaiaCounterIsLoading">{{amaiaCounter}}</a>
            </div>
        </div>
        <mat-card>
            <mat-card-header>
                <div mat-card-avatar class="amaia-avatar"></div>
                <mat-card-title>Amaia</mat-card-title>
                <mat-card-subtitle>Latest feed</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="table-container">
                    <div class="loading-shade"
                         *ngIf="amaiaIsLoading || amaiaHasError">
                        <mat-spinner *ngIf="amaiaIsLoading"></mat-spinner>
                        <div class="error" *ngIf="amaiaHasError">
                            An error has occurred, please try again later.
                        </div>
                    </div>

                    <mat-table mat-table [dataSource]="amaiaSource" matSort>
                        <ng-container matColumnDef="Created at">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Created at</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Created at"> {{(element.created_at ? (element.created_at | date) : (119731017 | date))}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Name</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Name"> {{element.name}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Email">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Email</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Email"> {{element.email}} </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="amaiaColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: amaiaColumns;" [routerLink]="['/amaia/users/edit', row.name]"></mat-row>
                    </mat-table>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button [routerLink]="['amaia/users']">More</button>
            </mat-card-actions>
        </mat-card>
    </div>
    <div class="col-12 col-lg-6">
        <div class="counter-wrapper mat-elevation-z1">
            <div>
                <h2>Idc contents</h2>
                <p>
                    Current amount of contents submitted to the idc app.
                </p>
            </div>
            <div class="counter counter--warn">
                <mat-spinner diameter="30" color="accent" *ngIf="idcCounterIsLoading"></mat-spinner>
                <a *ngIf="!idcCounterIsLoading">{{idcCounter}}</a>
            </div>
        </div>
        <mat-card>
            <mat-card-header>
                <div mat-card-avatar class="idc-avatar"></div>
                <mat-card-title>I don't care!</mat-card-title>
                <mat-card-subtitle>Latest feed</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <div class="table-container">
                    <div class="loading-shade"
                         *ngIf="idcIsLoading || idcHasError">
                        <mat-spinner color="accent" *ngIf="idcIsLoading"></mat-spinner>
                        <div class="error" *ngIf="idcHasError">
                            An error has occurred, please try again later.
                        </div>
                    </div>
                    <mat-table mat-table [dataSource]="idcSource" matSort>
                        <ng-container matColumnDef="Created at">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Created at</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Created at"> {{element.created_at | date}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Title">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Title</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Title"> {{element.title}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Author">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Author</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Author"> {{element.author.name}} </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Contents">
                            <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Contents</mat-header-cell>
                            <mat-cell *matCellDef="let element" data-label="Contents"> {{element.contents.length}} </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="idcColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: idcColumns;" (click)="goToIdcPost(row)"></mat-row>
                    </mat-table>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button [routerLink]="['idc/posts']">More</button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
